import { makeAutoObservable } from 'mobx';
import { validatePriceIntersectsFirstCandle } from './validatePriceIntersectsFirstCandle';

export class PriceIntersectsFirstCandleData {
  candleDuration = 1;
  candleBarrier = 'HIGH';
  direction = 'ABOVE';

  constructor(initialData) {
    makeAutoObservable(this);
    if (initialData) {
      Object.keys(initialData).forEach(
        (field) => (this[field] = initialData[field])
      );
    }
  }

  resetToDefaults = () => {
    this.candleDuration = 1;
    this.candleBarrier = 'HIGH';
    this.direction = 'ABOVE';
  };
  updateTactic = (dataObj) => {
    for (const key in dataObj) {
      this[key] = dataObj[key];
    }
  };
  validate = (tradePlan) => {
    const data = {
      candleDuration: this.candleDuration,
      candleBarrier: this.candleBarrier,
      direction: this.direction,
      tradePlan,
    };
    const result = validatePriceIntersectsFirstCandle(data);
    return result;
  };
  returnJson = () => {
    return {
      candleDuration: this.candleDuration,
      candleBarrier: this.candleBarrier,
      direction: this.direction,
    };
  };
  setCandleDuration = (number) => {
    this.candleDuration = number;
  };

  setCandleBarrier = (string) => {
    this.candleBarrier = string;
  };
  setCandleDirection = (string) => {
    this.direction = string;
  };
}
